import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthProvider';
import { Unauthorized } from '../../components/Unauthorized/Unauthorized';
import { LoginPage } from '../../pages/LoginPage';

export interface PublicRoutesProps {}

// Summary: Mounts unauthenticated router tree and guards protected URLs with Unauthorized screens.
// Details: docs/function-library/web/routes.md#routes-publicroutes-publicroutes
export const PublicRoutes: React.FC<PublicRoutesProps> = () => {
    const { isAuthenticated } = useAuth();

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="/login" element={<LoginPage />} />
                {!isAuthenticated && (
                    <Route path="/pos" element={<Unauthorized />} />
                )}
                {!isAuthenticated && (
                    <Route path="/users" element={<Unauthorized />} />
                )}
                {!isAuthenticated && (
                    <Route path="/tenants" element={<Unauthorized />} />
                )}
                {!isAuthenticated && (
                    <Route path="/terminals" element={<Unauthorized />} />
                )}
                {!isAuthenticated && (
                    <Route path="/monitoring" element={<Unauthorized />} />
                )}
                {!isAuthenticated && (
                    <Route path="/t/:tenantId/pos" element={<Unauthorized />} />
                )}
                {!isAuthenticated && (
                    <Route path="/t/:tenantId/dashboard" element={<Unauthorized />} />
                )}
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </BrowserRouter>
    );
};
